import { FC } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import {
  FaIcon,
  ListItem,
  QuizSurveyModal,
  Resource,
  ResourceTexts,
  TResource,
  useMarkResourceAsRead,
} from '@fe-learner-common';
import { faBullseyePointer } from '@fortawesome/pro-regular-svg-icons/faBullseyePointer';
import { faSealQuestion } from '@fortawesome/pro-regular-svg-icons/faSealQuestion';
import { useConfigContext } from '@fe-core/context';

type QuizSurveyProps = {
  resource: TResource;
  participationId: string;
  texts: ResourceTexts;
  container: HTMLElement;
};

export const QuizSurvey: FC<QuizSurveyProps> = ({
  resource,
  participationId,
  texts,
  container,
  ...rest
}) => {
  const { config } = useConfigContext();
  const { mutate: markAsRead } = useMarkResourceAsRead({
    resourceId: resource.rid,
    participationId,
  });
  const url =
    resource.link ||
    `${config.apiUrls.aleweb}/participation/${participationId}/resource/${resource.rid}/useDirect`;

  const typeText =
    texts.groupTypes[
      resource.componentType === 'material-scorequiz' ? 'quiz' : 'survey'
    ];

  const Trigger = () => (
    <ListItem role="article" aria-label={typeText} className="flex">
      <Dialog.Trigger asChild>
        <button
          className="l-btn l-btn-tertiary flex w-full flex-1 items-center justify-between gap-x-4 overflow-hidden p-3"
          onClick={() => {
            markAsRead();
          }}
          {...rest}
        >
          <Resource
            resourceId={resource.rid}
            title={resource.material.webTitle}
            groupType={resource.groupType}
            thumbnail={resource.material.thumbnail}
            tags={resource.tags}
            isNew={resource.newResource}
            texts={texts}
          />
          <FaIcon
            className="m-2 text-neutral-500 max-md:mb-auto"
            width={16}
            height={16}
            icon={
              resource.componentType === 'material-scorequiz'
                ? faBullseyePointer
                : faSealQuestion
            }
          />
        </button>
      </Dialog.Trigger>
    </ListItem>
  );

  return (
    <QuizSurveyModal
      container={container}
      title={typeText}
      Trigger={Trigger}
      src={url}
    />
  );
};
